import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-blue-100 border-blue-400 text-blue-700 border px-4 py-3 rounded"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("受付番号は ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "text-3xl font-medium" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("になります。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.seminarDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.seminarDetails.seminar_category.id === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 参加登録を受付いたしました。 "))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.categoryName) + "の参加登録を、 ", 1),
              _hoisted_4,
              _createTextVNode("「" + _toDisplayString(_ctx.seminarDetails.seminar_user.seminar_status.name) + "」で受付いたしました。 ", 1),
              _hoisted_5
            ])),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, "[" + _toDisplayString(_ctx.seminarDetails.seminar_user.order_key) + "]", 1),
        _hoisted_10,
        _hoisted_11
      ]))
    : _createCommentVNode("", true)
}